import Amplify from 'aws-amplify'
import { displayMessage } from '../helpers/helper.js'
import { i18n } from '@/i18n'

export const OrderSettingsService = {
  /**
   * Retrieves settings for a given country using its ISO3 code.
   *
   * This function sends a GET request to the `/v1/settings/:countryIso3` endpoint using Amplify's API.
   * If the settings for the specified country are not found (404 error) and the country is not France (`FRA`),
   * it retries the request using `'FRA'` as a fallback.
   * Displays an error message if the request fails for other reasons.
   *
   * @async
   * @function get
   * @param {string} accessToken - Access token used for authenticating the API request.
   * @param {string} countryIso3 - ISO3 code of the country for which to retrieve settings.
   * @returns {Promise<Object|undefined>} - The settings object if found, otherwise `undefined`.
   *
   * @throws {Error} - Logs the error and displays a user-friendly message if the request fails.
   */
  async get(accessToken, countryIso3) {
    this.loadingBtn = true
    const myInit = {
      headers: {
        Authorization: 'Bearer ' + accessToken,
      },
    }
    try {
      return await Amplify.API.get('settings', '/v1/settings/' + countryIso3, myInit)
    } catch (e) {
      if (e.response?.status === 404 && countryIso3 !== 'FRA') {
        console.log(`No settings for country ${this.currentStoreDetails?.address?.country_id}`)
        return await this.get(accessToken, 'FRA')
      } else {
        displayMessage(i18n.t('settings.errorLoadingSettings'))
      }
    } finally {
      this.loadingBtn = false
    }
  },
}
